(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-home-remake-top"] && !Shopify.designMode) return;
  try {
    
  const fixShippingBarCopy = () => {
    document.querySelectorAll('.essential_free_shipping_bar_wrapper [class*="free_shipping_bar_title"]').forEach((element) => {
      if (element.textContent.includes('Breplačna dostava') || element.textContent.includes('€40,00')) {
        element.textContent = 'Brezplačna dostava za naročila nad 40 €!'
      }
    })
  }

  window.ltShippingCopyObserver?.disconnect()
  fixShippingBarCopy()
  window.ltShippingCopyObserver = new MutationObserver(fixShippingBarCopy)
  window.ltShippingCopyObserver.observe(document.body, { childList: true, subtree: true, characterData: true })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-product-v2"] && !Shopify.designMode) return;
  try {
    
  const initializeProductV2 = () => {
    const root = document.querySelector('[data-lt-product-v2-prototype]');
    if (!root || root.dataset.ltInitialized === 'true') return;
    root.dataset.ltInitialized = 'true';

    const guide = root.querySelector('.lt-product-v2-guide__details');
    if (guide) guide.open = window.matchMedia('(min-width: 750px)').matches;

    const calculator = root.querySelector('[data-lt-product-v2-calculator]');
    if (!calculator) return;

    const weight = calculator.querySelector('[data-lt-product-v2-weight]');
    const goal = calculator.querySelector('[data-lt-product-v2-goal]');
    const pack = calculator.querySelector('[data-lt-product-v2-pack]');
    const days = calculator.querySelector('[data-lt-product-v2-days]');
    const daily = calculator.querySelector('[data-lt-product-v2-daily]');

    const update = () => {
      const selectedWeight = weight.selectedOptions[0];
      const dailyAmount = Number(selectedWeight.dataset[goal.value]);
      const packSize = Number(pack.value);
      if (!Number.isFinite(dailyAmount) || dailyAmount <= 0) {
        days.textContent = 'Ni podatka';
        daily.textContent = 'za izbrano kombinacijo';
        return;
      }
      const duration = Math.max(1, Math.floor(packSize / dailyAmount));
      days.textContent = `${duration} dni`;
      daily.textContent = `pri ${dailyAmount} g na dan`;
    };

    weight.addEventListener('change', update);
    goal.addEventListener('change', update);
    pack.addEventListener('change', update);
    update();

    const overlay = document.querySelector('[data-lt-product-v2-picker-overlay]');
    const title = overlay?.querySelector('.lt-product-v2-picker-title');
    const optionsWrap = overlay?.querySelector('.lt-product-v2-picker-options');
    const done = overlay?.querySelector('.lt-product-v2-picker-done');
    if (!overlay || !title || !optionsWrap || !done) return;

    const pickerLabels = new Map([
      [weight, weight.closest('label')?.querySelector('span')?.textContent || 'Izberite težo'],
      [goal, goal.dataset.ltPickerTitle || goal.closest('label')?.querySelector('span')?.textContent || 'Izberite cilj'],
      [pack, pack.closest('label')?.querySelector('span')?.textContent || 'Izberite pakiranje']
    ]);

    let activeSelect = null;
    let activeTrigger = null;
    let pendingValue = null;
    let previousBodyOverflow = '';

    const selectOption = (button) => {
      pendingValue = button.dataset.value;
      optionsWrap.querySelectorAll('.lt-product-v2-picker-option').forEach((option) => {
        option.setAttribute('aria-checked', String(option === button));
      });
    };

    const closePicker = (commit) => {
      if (!activeSelect || !activeTrigger) return;
      if (commit && pendingValue !== null) {
        activeSelect.value = pendingValue;
        activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        activeTrigger.querySelector('span').textContent = activeSelect.selectedOptions[0].textContent;
      }
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousBodyOverflow;
      const triggerToFocus = activeTrigger;
      activeSelect = null;
      activeTrigger = null;
      pendingValue = null;
      window.setTimeout(() => triggerToFocus.focus(), 0);
    };

    const openPicker = (select, trigger, dialogTitle) => {
      activeSelect = select;
      activeTrigger = trigger;
      pendingValue = select.value;
      title.textContent = dialogTitle;
      optionsWrap.replaceChildren();

      Array.from(select.options).forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lt-product-v2-picker-option';
        button.dataset.value = option.value;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(option.value === select.value));
        button.textContent = option.textContent;
        button.addEventListener('click', () => selectOption(button));
        optionsWrap.appendChild(button);
      });

      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      window.setTimeout(() => {
        optionsWrap.querySelector('[aria-checked="true"]')?.focus();
      }, 0);
    };

    done.addEventListener('click', () => closePicker(true));
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePicker(false);
      }
    });

    pickerLabels.forEach((dialogTitle, select) => {
      const trigger = select.nextElementSibling;
      if (!trigger?.classList.contains('lt-product-v2-picker-trigger')) return;
      trigger.addEventListener('click', () => openPicker(select, trigger, dialogTitle));
    });

    const reserve = document.querySelector('.lt-product-v2-bundler-reserve');
    const productForm = document.querySelector('[id^="MainProduct-"] product-form.product-form');
    if (reserve && productForm) {
      const releaseReserve = () => {
        if (!productForm.querySelector('.bundler-volume-target-element')) return false;
        reserve.hidden = true;
        return true;
      };

      if (!releaseReserve()) {
        const observer = new MutationObserver(() => {
          if (!releaseReserve()) return;
          observer.disconnect();
        });
        observer.observe(productForm, { childList: true, subtree: true });
        window.setTimeout(() => {
          if (!releaseReserve()) reserve.hidden = true;
          observer.disconnect();
        }, 8000);
      }
    }
  };

  initializeProductV2();
  document.addEventListener('shopify:section:load', initializeProductV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-rabbit-production"] && !Shopify.designMode) return;
  try {
    
  const initializeRabbitPrototype = () => {
    const root = document.querySelector('[data-lt-rabbit-prototype]');
    if (!root || root.dataset.ltInitialized === 'true') return;
    root.dataset.ltInitialized = 'true';

    const guide = root.querySelector('.lt-rabbit-guide__details');
    if (guide) guide.open = window.matchMedia('(min-width: 750px)').matches;

    const calculator = root.querySelector('[data-lt-rabbit-calculator]');
    if (!calculator) return;

    const weight = calculator.querySelector('[data-lt-rabbit-weight]');
    const goal = calculator.querySelector('[data-lt-rabbit-goal]');
    const pack = calculator.querySelector('[data-lt-rabbit-pack]');
    const days = calculator.querySelector('[data-lt-rabbit-days]');
    const daily = calculator.querySelector('[data-lt-rabbit-daily]');

    const update = () => {
      const selectedWeight = weight.selectedOptions[0];
      const dailyAmount = Number(selectedWeight.dataset[goal.value]);
      const packSize = Number(pack.value);
      const duration = Math.max(1, Math.floor(packSize / dailyAmount));
      days.textContent = `${duration} dni`;
      daily.textContent = `pri ${dailyAmount} g na dan`;
    };

    weight.addEventListener('change', update);
    goal.addEventListener('change', update);
    pack.addEventListener('change', update);
    update();

    const overlay = document.querySelector('[data-lt-rabbit-picker-overlay]');
    const title = overlay?.querySelector('.lt-rabbit-picker-title');
    const optionsWrap = overlay?.querySelector('.lt-rabbit-picker-options');
    const done = overlay?.querySelector('.lt-rabbit-picker-done');
    if (!overlay || !title || !optionsWrap || !done) return;

    const pickerLabels = new Map([
      [weight, 'Izberite težo psa'],
      [goal, 'Izberite cilj hranjenja'],
      [pack, 'Izberite pakiranje']
    ]);

    let activeSelect = null;
    let activeTrigger = null;
    let pendingValue = null;
    let previousBodyOverflow = '';

    const selectOption = (button) => {
      pendingValue = button.dataset.value;
      optionsWrap.querySelectorAll('.lt-rabbit-picker-option').forEach((option) => {
        option.setAttribute('aria-checked', String(option === button));
      });
    };

    const closePicker = (commit) => {
      if (!activeSelect || !activeTrigger) return;
      if (commit && pendingValue !== null) {
        activeSelect.value = pendingValue;
        activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        activeTrigger.querySelector('span').textContent = activeSelect.selectedOptions[0].textContent;
      }
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousBodyOverflow;
      const triggerToFocus = activeTrigger;
      activeSelect = null;
      activeTrigger = null;
      pendingValue = null;
      window.setTimeout(() => triggerToFocus.focus(), 0);
    };

    const openPicker = (select, trigger, dialogTitle) => {
      activeSelect = select;
      activeTrigger = trigger;
      pendingValue = select.value;
      title.textContent = dialogTitle;
      optionsWrap.replaceChildren();

      Array.from(select.options).forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lt-rabbit-picker-option';
        button.dataset.value = option.value;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(option.value === select.value));
        button.textContent = option.textContent;
        button.addEventListener('click', () => selectOption(button));
        optionsWrap.appendChild(button);
      });

      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      window.setTimeout(() => {
        optionsWrap.querySelector('[aria-checked="true"]')?.focus();
      }, 0);
    };

    done.addEventListener('click', () => closePicker(true));
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePicker(false);
      }
    });

    pickerLabels.forEach((dialogTitle, select) => {
      const trigger = select.nextElementSibling;
      if (!trigger?.classList.contains('lt-rabbit-picker-trigger')) return;
      trigger.addEventListener('click', () => openPicker(select, trigger, dialogTitle));
    });

    const reserve = document.querySelector('.lt-rabbit-bundler-reserve');
    const productForm = document.querySelector('[id^="MainProduct-"] product-form.product-form');
    if (reserve && productForm) {
      const releaseReserve = () => {
        if (!productForm.querySelector('.bundler-volume-target-element')) return false;
        reserve.hidden = true;
        return true;
      };

      if (!releaseReserve()) {
        const observer = new MutationObserver(() => {
          if (!releaseReserve()) return;
          observer.disconnect();
        });
        observer.observe(productForm, { childList: true, subtree: true });
      }
    }
  };

  initializeRabbitPrototype();
  document.addEventListener('shopify:section:load', initializeRabbitPrototype);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-rabbit-prototype"] && !Shopify.designMode) return;
  try {
    
  const initializeRabbitPrototype = () => {
    const root = document.querySelector('[data-lt-rabbit-prototype]');
    if (!root || root.dataset.ltInitialized === 'true') return;
    root.dataset.ltInitialized = 'true';

    const guide = root.querySelector('.lt-rabbit-guide__details');
    if (guide) guide.open = window.matchMedia('(min-width: 750px)').matches;

    const calculator = root.querySelector('[data-lt-rabbit-calculator]');
    if (!calculator) return;

    const weight = calculator.querySelector('[data-lt-rabbit-weight]');
    const goal = calculator.querySelector('[data-lt-rabbit-goal]');
    const pack = calculator.querySelector('[data-lt-rabbit-pack]');
    const days = calculator.querySelector('[data-lt-rabbit-days]');
    const daily = calculator.querySelector('[data-lt-rabbit-daily]');

    const update = () => {
      const selectedWeight = weight.selectedOptions[0];
      const dailyAmount = Number(selectedWeight.dataset[goal.value]);
      const packSize = Number(pack.value);
      const duration = Math.max(1, Math.floor(packSize / dailyAmount));
      days.textContent = `${duration} dni`;
      daily.textContent = `pri ${dailyAmount} g na dan`;
    };

    weight.addEventListener('change', update);
    goal.addEventListener('change', update);
    pack.addEventListener('change', update);
    update();

    const overlay = document.querySelector('[data-lt-rabbit-picker-overlay]');
    const title = overlay?.querySelector('.lt-rabbit-picker-title');
    const optionsWrap = overlay?.querySelector('.lt-rabbit-picker-options');
    const done = overlay?.querySelector('.lt-rabbit-picker-done');
    if (!overlay || !title || !optionsWrap || !done) return;

    const pickerLabels = new Map([
      [weight, 'Izberite težo psa'],
      [goal, 'Izberite cilj hranjenja'],
      [pack, 'Izberite pakiranje']
    ]);

    let activeSelect = null;
    let activeTrigger = null;
    let pendingValue = null;
    let previousBodyOverflow = '';

    const selectOption = (button) => {
      pendingValue = button.dataset.value;
      optionsWrap.querySelectorAll('.lt-rabbit-picker-option').forEach((option) => {
        option.setAttribute('aria-checked', String(option === button));
      });
    };

    const closePicker = (commit) => {
      if (!activeSelect || !activeTrigger) return;
      if (commit && pendingValue !== null) {
        activeSelect.value = pendingValue;
        activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        activeTrigger.querySelector('span').textContent = activeSelect.selectedOptions[0].textContent;
      }
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousBodyOverflow;
      const triggerToFocus = activeTrigger;
      activeSelect = null;
      activeTrigger = null;
      pendingValue = null;
      window.setTimeout(() => triggerToFocus.focus(), 0);
    };

    const openPicker = (select, trigger, dialogTitle) => {
      activeSelect = select;
      activeTrigger = trigger;
      pendingValue = select.value;
      title.textContent = dialogTitle;
      optionsWrap.replaceChildren();

      Array.from(select.options).forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lt-rabbit-picker-option';
        button.dataset.value = option.value;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(option.value === select.value));
        button.textContent = option.textContent;
        button.addEventListener('click', () => selectOption(button));
        optionsWrap.appendChild(button);
      });

      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      window.setTimeout(() => {
        optionsWrap.querySelector('[aria-checked="true"]')?.focus();
      }, 0);
    };

    done.addEventListener('click', () => closePicker(true));
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePicker(false);
      }
    });

    pickerLabels.forEach((dialogTitle, select) => {
      const trigger = select.nextElementSibling;
      if (!trigger?.classList.contains('lt-rabbit-picker-trigger')) return;
      trigger.addEventListener('click', () => openPicker(select, trigger, dialogTitle));
    });

    const reserve = document.querySelector('.lt-rabbit-bundler-reserve');
    const productForm = document.querySelector('[id^="MainProduct-"] product-form.product-form');
    if (reserve && productForm) {
      const releaseReserve = () => {
        if (!productForm.querySelector('.bundler-volume-target-element')) return false;
        reserve.hidden = true;
        return true;
      };

      if (!releaseReserve()) {
        const observer = new MutationObserver(() => {
          if (!releaseReserve()) return;
          observer.disconnect();
        });
        observer.observe(productForm, { childList: true, subtree: true });
      }
    }
  };

  initializeRabbitPrototype();
  document.addEventListener('shopify:section:load', initializeRabbitPrototype);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-wet-dog-prototype"] && !Shopify.designMode) return;
  try {
    
const initializeWetDogPrototype = () => {
  const root = document.querySelector('[data-lt-wet-dog-prototype]');
  if (!root || root.dataset.ltInitialized === 'true') return;
  root.dataset.ltInitialized = 'true';

  const guide = root.querySelector('.lt-wet-dog-guide__details');
  if (guide) guide.open = window.matchMedia('(min-width: 750px)').matches;

  const reserve = document.querySelector('.lt-wet-dog-bundler-reserve');
  const productInfo = document.querySelector('[id^="ProductInfo-"]');
  if (reserve && productInfo) {
    const releaseReserve = () => {
      if (!productInfo.querySelector('.bundler-volume-target-element')) return false;
      reserve.hidden = true;
      return true;
    };
    if (!releaseReserve()) {
      const observer = new MutationObserver(() => {
        if (!releaseReserve()) return;
        observer.disconnect();
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }
  }
};
initializeWetDogPrototype();
document.addEventListener('shopify:section:load', initializeWetDogPrototype);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-wet-rabbit-production"] && !Shopify.designMode) return;
  try {
    
const initializeWetRabbitPrototype = () => {
  const root = document.querySelector('[data-lt-wet-rabbit-prototype]');
  if (!root || root.dataset.ltInitialized === 'true') return;
  root.dataset.ltInitialized = 'true';

  const guide = root.querySelector('.lt-wet-rabbit-guide__details');
  if (guide) guide.open = window.matchMedia('(min-width: 750px)').matches;

  const reserve = document.querySelector('.lt-wet-rabbit-bundler-reserve');
  const productInfo = document.querySelector('[id^="ProductInfo-"]');
  if (reserve && productInfo) {
    const releaseReserve = () => {
      if (!productInfo.querySelector('.bundler-volume-target-element')) return false;
      reserve.hidden = true;
      return true;
    };
    if (!releaseReserve()) {
      const observer = new MutationObserver(() => {
        if (!releaseReserve()) return;
        observer.disconnect();
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }
  }
};
initializeWetRabbitPrototype();
document.addEventListener('shopify:section:load', initializeWetRabbitPrototype);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-wet-rabbit-prototype"] && !Shopify.designMode) return;
  try {
    
const initializeWetRabbitPrototype = () => {
  const root = document.querySelector('[data-lt-wet-rabbit-prototype]');
  if (!root || root.dataset.ltInitialized === 'true') return;
  root.dataset.ltInitialized = 'true';

  const guide = root.querySelector('.lt-wet-rabbit-guide__details');
  if (guide) guide.open = window.matchMedia('(min-width: 750px)').matches;

  const reserve = document.querySelector('.lt-wet-rabbit-bundler-reserve');
  const productInfo = document.querySelector('[id^="ProductInfo-"]');
  if (reserve && productInfo) {
    const releaseReserve = () => {
      if (!productInfo.querySelector('.bundler-volume-target-element')) return false;
      reserve.hidden = true;
      return true;
    };
    if (!releaseReserve()) {
      const observer = new MutationObserver(() => {
        if (!releaseReserve()) return;
        observer.disconnect();
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }
  }
};
initializeWetRabbitPrototype();
document.addEventListener('shopify:section:load', initializeWetRabbitPrototype);

  } catch(e) { console.error(e); }
})();
})();
